import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'info' | 'success' | 'error';
  $hasDescription: number;
}

const toastTypeVariations = {
  info: css`
    background: ${({ theme }) => theme.palette.blue.main.hex()};
    color: ${({ theme }) => theme.palette.blue.toast.hex()};
  `,

  success: css`
    background: ${({ theme }) => theme.palette.green._300.hex()};
    color: ${({ theme }) => theme.palette.green._700.hex()};
  `,

  error: css`
    background: ${({ theme }) => theme.palette.pink._100.hex()};
    color: ${({ theme }) => theme.palette.pink._500.hex()};
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 360px;

  position: relative;
  z-index: 1301;
  padding: 16px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;

  & + div {
    margin-top: 8px;
  }

  ${props => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.7;
      line-height: 20px;
    }
  }

  button {
    position: absolute;
    right: 8px;
    top: 7px;
    opacity: 0.5;
    border: 0;
    background: transparent;
    color: inherit;
  }

  ${props =>
    !props.$hasDescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
